import { Pressable, View } from "react-native";
import Animated, { FadeInDown } from "react-native-reanimated";
import { Snowflake } from "lucide-react-native";
import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";
import { semanticColors } from "@louise/theme/tokens";

type Props = {
  label: string;
  index: number;
  Icon: typeof Snowflake;
  onPress?: () => void;
};

export default function AnswerChip({ label, index, Icon, onPress }: Props) {
  const capturePress = usePressCapture("AnswerChip");
  const chip = (
    <Animated.View
      entering={FadeInDown.springify()
        .damping(14)
        .stiffness(150)
        .delay(index * 60)}
      style={{
        width: 30,
        height: 30,
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 999,
        backgroundColor: semanticColors.onDark.fill.subtle,
        borderWidth: 1,
        borderColor: semanticColors.onDark.fill.strong,
      }}
    >
      <Icon
        size={15}
        color={semanticColors.onDark.text.secondary}
        strokeWidth={1.6}
      />
    </Animated.View>
  );

  if (onPress) {
    return (
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={label}
        hitSlop={6}
        onPress={() => {
          capturePress(pressLabel(label), "onboarding_answer_chip");
          onPress();
        }}
      >
        {chip}
      </Pressable>
    );
  }
  return (
    <View accessible accessibilityLabel={label} accessibilityRole="image">
      {chip}
    </View>
  );
}
